import React from "react";
import styles from "../BrandOfTheMonthModal.module.scss";
import Spinner from "../../../../utils/loader/Spinner";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {emailRegExp} from "../../../../../helpers/emailRegExp";
import loginFormStyles from "./LoginForm.module.scss";
import {useAppDispatch, useCustomerSelector} from "../../../../../store";
import {loginCustomer} from "../../../../../store/slices/customerSlice";

type LoginFormState = {
  email: string;
  password: string;
};

const LoginForm: React.FC<{onLoggedIn: (success: boolean) => void}> = ({onLoggedIn}) => {
  const {customer} = useCustomerSelector();
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const {
    formState: {errors, isSubmitting},
    register,
    handleSubmit,
  } = useForm<LoginFormState>({mode: "onSubmit", defaultValues: {email: customer.email ?? ""}});

  const onSubmit = async (data: LoginFormState) => {
    const {email, password} = data;
    if (Object.keys(errors).length !== 0) {
      return;
    }

    const success = await dispatch(loginCustomer({username: email, password}));
    onLoggedIn(success.payload as boolean);
  };

  return (
    <form className={`${styles.bomForm} ${loginFormStyles.loginForm}`} noValidate onSubmit={handleSubmit(onSubmit)}>
      <div className={loginFormStyles.inputWrapper}>
        <input
          type="email"
          placeholder={t("form.yourEmailAddress")}
          className={errors.email ? styles.invalid : ""}
          {...register("email", {
            required: t("form.pleaseComplete"),
            pattern: {value: emailRegExp, message: t("form.typeInValidEmailAddress")},
          })}
        />
        {errors.email && <span className={styles.errorMessageInput}>{errors.email.message}</span>}
      </div>

      <div className={loginFormStyles.inputWrapper}>
        <input
          type="password"
          placeholder={t("form.yourPassword")}
          className={errors.password ? styles.invalid : ""}
          {...register("password", {required: t("form.pleaseComplete")})}
        />
        {errors.password && <span className={styles.errorMessageInput}>{errors.password.message}</span>}
      </div>

      <button type="submit" className="grow">
        {isSubmitting ? <Spinner /> : <>{t("customer.logIn")}</>}
      </button>
    </form>
  );
};

export default LoginForm;
